<template>
  <div class="mobile-repair">
    <a-space class="section-space" :size="20">
      <div @click="addRepairRecord" class="button">新增返修设备</div>
      <div @click="searchRepairRecord" class="button">搜索</div>
    </a-space>
    <div class="title">设备信息</div>
    <template v-for="(item, index) in repairList.tableData" :key="index">
      <div class="after-sale-question">
        <div class="df">
          <p>机身号</p>
          <div class="content">{{ item.serial }}</div>
        </div>
        <div class="df">
          <p>返厂时间</p>
          <div class="content">{{ item.returnDate }}</div>
        </div>
        <div class="df">
          <p>返厂地址</p>
          <div class="content">{{ item.returnAddress }}</div>
        </div>
        <div class="df">
          <p>对接人</p>
          <div class="content">{{ item.contactPerson }}</div>
        </div>

        <div class="df">
          <p>流程状态</p>
          <div class="content">
            <a-tag color="pink" v-if="item.repairProcess === 0">仓管</a-tag>
            <a-tag color="red" v-if="item.repairProcess === 1">质检</a-tag>
            <a-tag color="orange" v-if="item.repairProcess === 2">工艺</a-tag>
            <a-tag color="green" v-if="item.repairProcess === 3">生产</a-tag>
            <a-tag color="cyan" v-if="item.repairProcess === 4">闭环</a-tag>
            <a-tag color="purple" v-if="item.repairProcess === 5">审核</a-tag>
            <a-tag color="#87d068" v-if="item.repairProcess === -1"
              >已完成
            </a-tag>
          </div>
        </div>
        <div>
          <p>售后问题描述</p>
          <div
            class="question"
            v-if="item.afterSaleProblemDescription !== '[]'"
          >
            <div
              class="content"
              v-for="(text, textIndex) in JSON.parse(
                item.afterSaleProblemDescription
              )"
              :key="textIndex"
            >
              {{ text.value }}
            </div>
          </div>
        </div>

        <div class="button-ground df df-around">
          <a-button
            @click="handleStartRepairProcess(item)"
            size="small"
            type="primary"
            v-if="item.repairProcess === null"
          >
            开启流程
          </a-button>
          <a-button size="small" @click="editForm(item)">编辑</a-button>
          <a-button size="small" type="parimary" @click="lookProcess(item)"
            >查看</a-button
          >
          <a-button size="small" type="danger" @click="handleDeleteRepair(item)"
            >删除</a-button
          >
        </div>
      </div>
    </template>

    <div class="pagination">
      <img
        src="@/assets/img/mobile/lease/prest.png"
        @click="handleUpdateList(1)"
      />
      <img
        src="@/assets/img/mobile/lease/pre.png"
        @click="handleUpdateList(repairList.page.pageNum - 1)"
      />
      <div class="size">
        {{ repairList.page.pageNum }}/{{
          Math.ceil(repairList.page.total / repairList.page.lineNum)
        }}
      </div>
      <img
        src="@/assets/img/mobile/lease/next.png"
        @click="handleUpdateList(repairList.page.pageNum + 1)"
      />
      <img
        src="@/assets/img/mobile/lease/nextest.png"
        @click="
          handleUpdateList(
            Math.ceil(repairList.page.total / repairList.page.lineNum)
          )
        "
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import {
  getRepairEquipmentList,
  deleteRepairEquipment,
  getRepairStatistics,
  getUserList,
  startRepairProcess,
  deleteUser,
} from "@/request/view/repair";
import { showModal } from "@/views/repairprogress/serve/modal";
import { Toast } from "@/utils/index";
import {
  repairList,
  handleUpdatePage,
  handleUpdateRequestPayload,
  getRepairListData,
} from "./serve/search";

export default defineComponent({
  props: {
    tableData: Array,
    columns: Array,
  },
  setup(props) {
    const route = useRoute();
    const store = useStore();
    const router = useRouter();

    const checkViewCustomInfo = () => {
      return Boolean(route.meta["/customerinformationviewing"]);
    };
    const searchRepairRecord = () => {
      router.push({
        path: "/mobilesearchrepair",
      });
    };

    const addRepairRecord = () => {
      if (!route.meta["/addrepairinformation"]) {
        return Toast("warning", "无权限", 3);
      }
      router.push({
        path: "/mobileaddrepair",
        query: {
          type: "addRepair",
        },
      });
    };

    // 页码更新
    const handleUpdateList = (page) => {
      let limtPage = null;
      const minPage = 1;
      const maxPage = Math.ceil(
        repairList.page.total / repairList.page.lineNum
      );
      if (page < minPage) {
        limtPage = 1;
        return Toast("warning", "首页", 3);
      } else if (page > maxPage) {
        limtPage = maxPage;
        return Toast("warning", "尾页", 3);
      } else {
        limtPage = page;
      }
      handleUpdatePage(limtPage);
      getRepairListData();
    };

    const init = () => {
      handleUpdateRequestPayload({ userId: store.state.user.user.id });
      getRepairListData();
    };

    const handleStartRepairProcess = (e) => {
      if (!route.meta["/deleterepairinformation"]) {
        return Toast("warning", "无权限", 3);
      }
      showModal({
        title: "提示",
        toastText: "确认开启返修流程？",
        success: () => {
          startRepairProcess({ id: e.id })
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              getRepairListData();
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const handleDeleteRepair = (e) => {
      if (!route.meta["/deleterepairinformation"]) {
        return Toast("warning", "无权限", 3);
      }
      showModal({
        title: "提示",
        toastText: "确认删除？",
        success: () => {
          deleteRepairEquipment([e.id])
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              getRepairListData();
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const editForm = (e) => {
      if (!route.meta["/updaterepairinformation"]) {
        return Toast("warning", "无权限", 3);
      }
      const customInfoAuthority = checkViewCustomInfo();
      console.log(customInfoAuthority, "这是什么");
      router.push({
        path: "/mobileaddrepair",
        query: {
          type: "echoRepairForm",
          data: JSON.stringify(e),
          authority: customInfoAuthority,
        },
      });
    };

    const lookProcess = (e) => {
      router.push({
        path: "/repairprogress",
        query: {
          machineId: e.id,
          type: e.serialType,
          semiFinishedProducts: e.semiFinishedProducts,
          componentsAndParts: e.componentsAndParts,
          attribute: e.attribute,
          returnDate: e.returnDate,
          replaceSerial: e.replaceSerial,
          newCode: e.newCode,
          repairProcess: e.repairProcess,
          principal: e.principal,
          completeDate: e.completeDate,
          auditTime: e.auditTime,
          username: e.username,
          userId: e.userId,
          afterSaleProblemDescription: e.afterSaleProblemDescription,
          video: e.video,
          picture: e.picture,
          contactPerson: e.contactPerson,
          serial: e.serial,
          meta: encodeURI(JSON.stringify(route.meta)),
        },
      });
    };

    init();

    return {
      searchRepairRecord,
      addRepairRecord,
      props,
      repairList,
      handleUpdateList,
      editForm,
      handleStartRepairProcess,
      handleDeleteRepair,
      lookProcess,
    };
  },
});
</script>

<style lang="less" scoped>
.mobile-repair {
  width: 100vw;
  height: 100vh;
  overflow: scroll;
  background: #f3f5f6;
  padding: 10px 15px 1.5rem;
  .button {
    padding: 5px 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background: #fff;
  }
  .section-space {
    margin: 10px 0;
  }
  .title {
    font-size: 20px;
    color: #263238;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .after-sale-question {
    padding: 16px 12px;
    background: #ffffff;
    box-shadow: 0px 1px 3px 0px rgba(38, 38, 38, 0.1),
      0px 3px 9px 1px rgba(38, 38, 38, 0.14);
    border-radius: 10px;
    margin-bottom: 24px;
    p {
      font-size: 16px;
      width: 100px;
      margin-bottom: 12px;
    }
    .content {
      font-size: 16px;
      color: #585c61;
    }
    .question {
      padding: 10px 16px;
      border: 1px solid #d9dce4;
      border-radius: 10px;
    }
    .button-ground {
      padding: 20px 0 0;
    }
  }
  .pagination {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0.2rem 0.84rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    img {
      width: 0.85rem;
      height: 0.85rem;
      display: block;
    }
    .size {
      width: 3.07rem;
      height: 0.91rem;
      text-align: center;
      line-height: 0.8rem;
      border: 0.07rem solid #143022;
      border-radius: 0.24rem;
      font-size: 0.37rem;
      color: #202020;
    }
  }
}
</style>
